<div class="dialog">
    <div class="dialog-title">
        <h6 class="pl-3">Review Cost Breakdown <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
    <div class="content container-fluid">
        <div class="row pl-3 pr-3 grey ml-0 no-padding mr-0">
            <h6 class="col-md-6 mt-1 no-padding head">PARTS</h6>
            <h6 class="col-md-3 mt-1 pr-0">Quantity</h6>
            <h6 class="col-md-3 text-right mt-1 pr-0">Amount({{currency}})</h6>
        </div>
        <div class="parts container-fluid">
            <div class="row border-bottom mb-2" *ngFor="let item of vendorItems">
                <div class="col-md-6">
                    <h6 [matTooltip]="item.model_attributes.file_name" class="sub text-truncate">{{item.model_attributes.file_name}}</h6>
                    <p class="light">{{item?.cleaned_model?.length}} X {{item?.cleaned_model?.width}} x
                        {{item?.cleaned_model?.height}}</p>
                </div>
                <div class="col-md-3 sub">
                    <h6 *ngFor="let batch of item?.dispatch_batch; let j=index" class="sub">{{batch?.name}}:
                        {{batch?.costing?.agreed_quantity}}</h6>
                </div>
                <div class="col-md-3 sub">
                    <h6 *ngFor="let batch of item?.dispatch_batch" class="text-right pr-0 sub">
                        {{batch?.costing?.agreed_quantity * batch?.costing?.total_unit_cost |
                        currency:currency}}</h6>
                </div>

            </div>
        </div>
        <div class="container-fluid row pr-0 mt-2 mb-2">
            <h6 class="pl-3 col-md-8 head">Sub Total</h6>
            <h6 class="col-md-4 text-right pr-0 head">{{rfqData?.bag_total | currency:currency}}</h6>
        </div>
        <div class="container-fluid row pr-0 mt-2 mb-2">
            <h6 class="pl-3 col-md-8 head">Discount</h6>
            <h6 class="col-md-4 text-right pr-0 head">{{rfqData?.total_discount | currency:currency}}</h6>
        </div>
        <!-- <div class="container-fluid row pr-0 mt-2 mb-2">
            <h6 class="pl-3 col-md-8 head">Shipping</h6>
            <h6 class="col-md-4 text-right pr-0 head ">{{rfqData?.delivery_cost | currency:'INR':"symbol-narrow":'1.2-2'}}</h6>
        </div> -->
        <div class="container-fluid row pr-0 mt-2 mb-2">
            <h6 class="pl-3 col-md-8 head">Taxes</h6>
            <h6 class="col-md-4 text-right pr-0 head">{{rfqData?.total_taxes | currency:currency}}</h6>
        </div>
        <div class="row pl-3 pr-3 grey ml-0 no-padding mr-0 mt-2 mb-2">
            <h6 class="col-md-8 mt-1 no-padding head">Total</h6>
            <h6 class="col-md-4 text-right mt-1 pr-0 head">{{rfqData?.grand_total ? (rfqData?.grand_total |
                currency:currency) : 'TBC'}}</h6>
        </div>

        <div class="row pl-3 pr-3 grey ml-0 no-padding mr-0">
            <h6 class="col-md-6 mt-1 no-padding head">Upload Costing File</h6>
        </div>
        <div class="parts container-fluid">
            <div class="file-drop primary-file-upload mb-2">
                <form [formGroup]="uploadFileForm" *ngIf="!file_report_uploaded">
                    <!-- <file-upload formControlName="files" accept=".pdf,.jpg,.jpeg,.png">
                        <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
                            <span *ngIf="isFileDragDropAvailable">
                                <div _ngcontent-c1="" class="w-75 upload-input ng-trigger ng-trigger-zoomAnimation">
                                    <div _ngcontent-c1="" class="icon ng-tns-c1-2 ng-star-inserted">
                                    </div>
                                    <br>
                                    <div class="upload-text ng-tns-c1-2 ng-star-inserted">
                                        <br>
                                        <img class="pl-2" src="assets/svg/upload-file.svg" alt="cube">
                                        <br>
                                        <b class="center ng-tns-c1-2 ng-star-inserted">Upload Costing Files</b>
                                        <p class="center ng-tns-c1-2 ng-star-inserted">Max size: 10 mb, Supported Formats: .pdf,.jpg,.jpeg,.png</p>
                                    </div>
                                </div>
                            </span>
                            <span *ngIf="!isFileDragDropAvailable">click</span>
                        </ng-template>
                    </file-upload> -->

                    <file-upload formControlName="files" accept=".pdf,.jpg,.jpeg,.png">
                        <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder
                            let-control="control" #button>
                            <span *ngIf="isFileDragDropAvailable">
                                <div _ngcontent-c1="" class="upload-input ng-trigger ng-trigger-zoomAnimation">
                                    <div class="text-center">
                                        <img class="mb-2" src="assets/svg/upload-file.svg" alt="cube">
                                    </div>
                                    <div class="upload-text ng-tns-c1-2 ng-star-inserted">
                                        <b class="center ng-tns-c1-2 ng-star-inserted ml-1">Upload Costing Files</b>
                                        <p class="mb-0 mt-2 drag-drop text-center">
                                            Max. file size 10 MB</p>
                                        <p class="mb-0 mt-1 text-center">
                                            (.pdf,.jpg,.jpeg,.png)</p>
                                    </div>
                                </div>
                            </span>
                            <span *ngIf="!isFileDragDropAvailable">click</span>
                        </ng-template>
                    </file-upload>
                </form>
                <div class="file-uploaded" *ngIf="file_report_uploaded">
                    <div *ngFor="let item of qualityReports; let i =index">
                        <p class="regular mb-3">{{item.name}}&nbsp;&nbsp;&nbsp;<img (click)="deleteQualityReport(i)"
                                class="pointer" src="assets/svg/Delete Default.svg" alt=""></p>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="footer row container-fluid pr-0 py-3">
        <div class="col-md-8">
        </div>
        <div class="col-md-4 d-flex button">
            <button class="white mr-2" (click)="close()">Back</button>
            <button class="orange ml-2" (click)="continue()">Continue</button>
        </div>

    </div>
</div>